import { useBox } from "@react-three/cannon";
import { useMemo, useRef } from "react";
import { Group, MeshBasicMaterial, TextureLoader } from "three";
import { RoundedBox } from "@react-three/drei";
import { ObjectProps, useDragConstraint } from "../utils";
import { useLoader } from "@react-three/fiber";
import { TwitterUrl, asset } from "../../consts";

export default ({position, rotation}: ObjectProps) => {
  const twitterImage = useLoader(TextureLoader, asset('/images/twitter.png'));

  const materials = useMemo(() => {
    const baseMaterial = new MeshBasicMaterial({color: '#1da1f2'});
    const twitterMaterial = new MeshBasicMaterial({ 
      color: 'blue',
      map: twitterImage,
      transparent: true,
      alphaTest: 0.1
    });
    
    return [
      baseMaterial.clone(),
      baseMaterial.clone(),
      twitterMaterial.clone(),
      twitterMaterial.clone(),
      baseMaterial.clone(),
      baseMaterial.clone(),
    ];
  }, [twitterImage]);
  const [ref] = useBox(() => ({
    mass: 5,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    args: [2.5, 1, 2.5],
    type: 'Dynamic'
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  const handlePointerEnter = () => { document.body.style.cursor = 'pointer'; };
  const handlePointerLeave = () => { document.body.style.cursor = 'default'; };
  const handleClick = () => { window.open(TwitterUrl, '_blank'); };
  return (
    <group
      ref={ref}
      {...bind}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      onClick={handleClick}
    >
      <RoundedBox
        args={[2.5, 1, 2.5]} 
        radius={0.5} 
        smoothness={4}
        castShadow
        receiveShadow
        material={materials}
      />
      <mesh
        position={[0, 0, 0]}
        rotation={[0, -Math.PI / 2, 0]}
        material={materials}
        receiveShadow>
          <boxGeometry args={[1, 1.002, 1]} />
        </mesh>
    </group>
  );
};
